import React from "react";
import { Box } from "@mui/material";
import "./LogoCarousel.css"; // animation + fade styles
import logo1 from "../img/runclublogos/BSR.png";
import logo2 from "../img/runclublogos/Badu.png";
import logo3 from "../img/runclublogos/Genesis logo.png";
import logo4 from "../img/runclublogos/szn focus.png";
import logo5 from "../img/runclublogos/Souls-Soles.png";
import logo6 from "../img/runclublogos/WeAreOne.jpg";
import logo7 from "../img/runclublogos/fra.jpg";
import logo8 from "../img/runclublogos/826 Active Logo Transparent.png";
import logo9 from "../img/runclublogos/BRKED OFF Run Club Logo Transparent.png";
import logo10 from "../img/runclublogos/Busy Run Club Logo Transparent.png";
import logo11 from "../img/runclublogos/Hackney Moves Run Club.png";
import logo12 from "../img/runclublogos/Run Dem Crew_Radio Logo Tranparent.png";
import logo13 from "../img/runclublogos/goodgym_red.png";
import logo14 from "../img/runclublogos/rep_runners.jpeg";


const logos = [logo1, logo2, logo3, logo4, logo5, logo6, logo7, logo8, logo13, logo14];

const LogoCarousel = () => {
  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        overflow: "hidden",
        py: 4,
        bgcolor: "white",
      }}
    >
      {/* Fading edges */}
      <Box className="fade-left" />
      <Box className="fade-right" />

      <Box className="logo-track">
        {[...logos, ...logos].map((logo, index) => (
          <Box
            key={index}
            component="img"
            src={logo}
            alt={`logo-${index}`}
            sx={{
              height: { xs: 40, sm: 50, md: 60 },
              mx: { xs: 4, sm: 5 },
              objectFit: "contain",
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default LogoCarousel;
